export const loadFeatures = (features) => {
	let request;

	return async () => {
		request ??= new Promise((resolve, reject) => {
			Shopify.loadFeatures(features, (error) => {
				if (error) reject(error);
				resolve(true);
			})
		});

		return request;
	}
};
